import { Validator } from '@vista-digital/validator';
export const defaultApiConfig = {
    url: undefined,
    authTokenProvider: undefined
};
export const apiConfigValidator = Validator.object({
    url: Validator.nonEmptyString,
    authTokenProvider: Validator.fn(),
    regionCode: Validator.optional(Validator.string({ minLength: 1, maxLength: 100 })),
    tenantId: Validator.optional(Validator.string({ minLength: 1, maxLength: 50 }))
});
//# sourceMappingURL=api.js.map